import React from "react";

import {
    LocationID,
    LocationProximity,
    getDealerIndices,
    isoLocationID,
} from "../../models";
import { LocationListItem } from "./LocationListItem";

import styles from "./LocationList.module.scss";

export const LocationList = (props: {
    locations: LocationProximity[];
    focusedLocationID: LocationID | null;
    onSelect: (id: LocationID) => void;
}) => {
    const dealerIndices = getDealerIndices(props.locations);
    return (
        <ul className={styles.ol}>
            {props.locations.map((locProx) => (
                <LocationListItem
                    key={`${isoLocationID.unwrap(locProx.location.id)}`}
                    index={
                        dealerIndices.get(
                            isoLocationID.unwrap(locProx.location.id),
                        ) ?? 0
                    }
                    focused={locProx.location.id === props.focusedLocationID}
                    onSelect={() => {
                        props.onSelect(locProx.location.id);
                    }}
                    {...locProx}
                />
            ))}
        </ul>
    );
};
